export default {
  data() {
    return {
      fullscreen: false,
    };
  },
  methods: {
    initPrevStep() {
      if (this.orderStep === 4) {
        let prevStep = null;

        if (this.product) {
          switch (this.product.slug) {
            case 'default':
            case 'digital':
              prevStep = `3-${this.product.slug}-more-photos`;
              break;
            default:
              prevStep = 4;
          }
        }

        this.$store.dispatch('ADD_PREV_ORDER_STEP', prevStep);
      }
    },
  },
  created() {
    this.initPrevStep();
  },
  mounted() {
    document.onkeydown = evt => {
      evt = evt || window.event;

      if (evt.keyCode === 27) {
        if (document.querySelector('.order')) {
          const modalContainer = document.getElementById('modals-container');

          if (modalContainer && modalContainer.children.length === 0) {
            this.closeOrder();
            this.$store.dispatch('SET_DRAWING', null);
          }
        }
      } else if ((evt.keyCode === 37 || evt.keyCode === 8)
          && this.photos.length > 1
          && document.getElementById('step1BtnPrev')
          && !document.getElementById('step1BtnPrev').
              classList.
              contains('prev--disabled')) {
        const step1BtnPrev = document.getElementById('step1BtnPrev');

        if (step1BtnPrev) {
          step1BtnPrev.click();
        }
      } else if (evt.keyCode === 39
          && this.photos.length > 1
          && document.getElementById('step1BtnNext')
          && !document.getElementById('step1BtnNext').
              classList.
              contains('next--disabled')) {
        const step1BtnNext = document.getElementById('step1BtnNext');

        if (step1BtnNext) {
          step1BtnNext.click();
        }
      } else if (evt.keyCode === 13) {
        document.getElementById('nextStepBtn') && document.getElementById('nextStepBtn').click();
      } else if (evt.keyCode === 70) {
        const addToFavoritesBtn = document.getElementById('addToFavoritesBtn');

        if (addToFavoritesBtn) {
          addToFavoritesBtn.click();
        }
      }
    };

    window.addEventListener('resize', () => {
      this.$store.dispatch('SET_DRAWING', null);
    });
  }
};
